import React, { useState } from 'react';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import ProjectSection from './components/ProjectSection';
import RendersGallery from './components/RendersGallery';
import FloorPlansSection from './components/FloorPlansSection';
import CurrentStateGallery from './components/CurrentStateGallery';
import LocationSection from './components/LocationSection';
import EsteponaSection from './components/EsteponaSection';
import ContactSection from './components/ContactSection';
import ContactFormModal from './components/ContactFormModal';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  const openContactModal = () => setIsContactModalOpen(true);
  const closeContactModal = () => setIsContactModalOpen(false);

  return (
    <LanguageProvider>
      <div className="App">
        <Header />
        <main>
          <Hero onOpenContactForm={openContactModal} />
          <ProjectSection />
          <RendersGallery />
          <FloorPlansSection />
          <CurrentStateGallery />
          <LocationSection />
          <EsteponaSection />
          <ContactSection onOpenContactForm={openContactModal} />
        </main>
        <Footer />
        <ContactFormModal 
          isOpen={isContactModalOpen} 
          onClose={closeContactModal} 
        />
      </div>
    </LanguageProvider>
  );
}

export default App;
